export default class Experience {
  static AgentCustomerOnboarding = 'agent_customer_onboarding';
  static AgentEndorsement = 'agent_endorsement';
}
